// App.js
import React from 'react';
import PremiumScheduleCard from './PremiumCard';
import { Grid, Typography } from "@material-ui/core";
import { extractEstimator } from "../TotalPaid/PolicyMainCard";

type premiumCardProps = {
    estimationResponse: any;
};



function PremiumCardWrap(props: premiumCardProps) {
    const { estimationResponse } = props;
    let {
        illustrationTables,
    } = extractEstimator(estimationResponse)
    const fiveYearContributionIndex = 0
    const sixto10YearContributionIndex = 6
    const OneTo5YearContribution = illustrationTables[fiveYearContributionIndex] && illustrationTables[fiveYearContributionIndex].contribution;
    const OneTo5YearBankContribution  = illustrationTables[fiveYearContributionIndex] && (illustrationTables[fiveYearContributionIndex].premiumpaid -  illustrationTables[fiveYearContributionIndex].contribution);

    const sixTo10YearContribution  = illustrationTables[sixto10YearContributionIndex] && illustrationTables[sixto10YearContributionIndex].contribution;
    const sixTo10BankContribution = illustrationTables[sixto10YearContributionIndex] && (illustrationTables[sixto10YearContributionIndex].premiumpaid -  illustrationTables[sixto10YearContributionIndex].contribution);

    // 5 years data
    const period1 = {
        years: '1-5',
        youPay: { amount: OneTo5YearContribution || 0  , bars: 3 },
        bankPays: { amount: OneTo5YearBankContribution || 0, bars: 3 },
    };

    const period2 = {
        years: '6-10',
        youPay: { amount: sixTo10YearContribution || 0, bars: 0 },
        bankPays: { amount: sixTo10BankContribution || 0, bars: 6 },
    };

    return (
            <div className="Card-container" style={{marginTop:40}}>
                <Typography variant="caption" className="colorWhite">Premium Payment Schedule</Typography>
                <Grid container spacing={4}>
                    <PremiumScheduleCard
                            years={period1.years}
                            youPay={period1.youPay}
                            bankPays={period1.bankPays}
                    />
                    <PremiumScheduleCard
                            years={period2.years}
                            youPay={period2.youPay}
                            bankPays={period2.bankPays}
                    />
                    </Grid>
            </div>
    );
}

export default PremiumCardWrap;